import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import router from "@/router";
import { InvitationService } from "@/services/InvitationService";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminCompanies',
  props: {
    companies: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();



const search = ref("");
const dialog = ref(false);
const inviteLink = ref("");
const inviteLoading = ref(false);

const invitationService = new InvitationService();

const headers = [
  { title: "Azonosító", key: "id" },
  { title: "Név", key: "name" },
  {
    title: "Részletek",
    key: "actions",
    align: "end" as const,
    sortable: false,
  },
];

const handleViewClick = (id: number) => {
  router.push(`/admin/companies/${id}`);
};

const generateInvite = async () => {
  inviteLoading.value = true;
  try {
    const token = await invitationService.createInvitation();
    inviteLink.value = `${window.location.origin}/register?token=${token}`;
    dialog.value = true;
  } finally {
    inviteLoading.value = false;
  }
};

const copyLink = () => {
  navigator.clipboard.writeText(inviteLink.value);
};

const __returned__ = { search, dialog, inviteLink, inviteLoading, invitationService, headers, handleViewClick, generateInvite, copyLink, ref, get router() { return router }, get InvitationService() { return InvitationService } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})